import { render } from "./deleteLlmSkillSetModal.vue?vue&type=template&id=36785437"
import script from "./deleteLlmSkillSetModal.vue?vue&type=script&lang=js"
export * from "./deleteLlmSkillSetModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__